var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"landing-page"},[_c('div',{staticClass:"lp-content-container"},[_c('div',{staticClass:"header"}),_c('div',{staticClass:"content"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('campaignLandingPage.hungerdaysContent'))}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }